// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"147":"63e1c637","347":"e5b8e1e5","525":"57e9d2e7","618":"f176e2f0","736":"5299ceb1","985":"c36fef6f"}[chunkId] + ".css";
};